import React from "react";
import { Stack, Heading, Text } from "@origin-digital/ods-core";

const Disclaimer: React.FC = () => {
  return (
    <Stack space="medium">
      <Heading variant="h4">Agreement</Heading>
      <Text>
        I understand and agree that upon installation of electricity for the
        supply address listed, it will be sold to me under the terms,
        conditions, and rates applicable to the multisite agreement in the
        welcome email. This includes any standard installation fee in addition
        to ongoing account charges.
      </Text>
    </Stack>
  );
};

export default Disclaimer;
